import { render, staticRenderFns } from "./ProfessionsList.vue?vue&type=template&id=3fff9fe2&scoped=true&"
import script from "./ProfessionsList.vue?vue&type=script&lang=js&"
export * from "./ProfessionsList.vue?vue&type=script&lang=js&"
import style0 from "./ProfessionsList.vue?vue&type=style&index=0&id=3fff9fe2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fff9fe2",
  null
  
)

export default component.exports